import React from 'react';
import Modal from "../../components/modal/modal";

export default function SuccessUploadModal({show, setter}) {
    return (
        <Modal show={show} setter={setter} name={'Subir Documentos'}>
            <div className={'mb-3'}>Se cargaron correctamente los archivos</div>
        </Modal>
    )
}